import { Injectable } from '@angular/core';

@Injectable()
export class LocalStorageService {
  constructor() {}

  getObject(id: any): any {
    if (localStorage.getItem(id) && localStorage.getItem(id) !== 'undefined') {
      const item = localStorage.getItem(id);
      const parsedItem = item !== null ? JSON.parse(item) : null;

      return parsedItem;
    } else {
      return false;
    }
  }

  getItem(key: any): any {
    if (localStorage.getItem(key) && localStorage.getItem(key) !== 'undefined') {
      return true;
    } else {
      return false;
    }
  }

  clearLocalStorage(hard?: any): void {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('encryptedRsaUserPrivate');
    localStorage.removeItem('encryptedUserAesKey');
    localStorage.removeItem('userKey');
    if (hard) {
      localStorage.clear();
    }
  }

  clearSafelockStorage(): void {
    localStorage.removeItem('encryptedRsaUserPrivate');
    localStorage.removeItem('encryptedUserAesKey');
    localStorage.removeItem('userKey');
  }
}
